// Stores and exports the currentScript dataset
const cs = document.currentScript;
export const dataset = cs ? { ...(cs.dataset || {}) } : {};
